import React from 'react';
import TodoPage from '../../TodoPage';
import { TodoPageFill, ViewRoot } from './styles';

interface TodoListViewProps {
  active: boolean;
}

const TodoListView: React.FC<TodoListViewProps> = ({ active }) => (
  <ViewRoot $active={active}>
    {active && (
      <TodoPageFill>
        <TodoPage hideUsergroupBar />
      </TodoPageFill>
    )}
  </ViewRoot>
);

export default TodoListView;
